var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"footer-link",attrs:{"href":"/conditions","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('conditions')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }